import toast, { ToastBar, Toaster as ToasterPrimitive, ToastOptions } from 'react-hot-toast';

import CheckIcon from '../icons/check';
import CloseIcon from '../icons/close';
import WarningIcon from '../icons/warning';

const defaultStyles: ToastOptions['style'] = {
  width: '400px',
  maxWidth: 'none',
  padding: '20px',
  color: 'white',
  borderRadius: '5px',
  fontWeight: '300',
  fontSize: '14px',
  justifyContent: 'start',
};

// Built once, outside the hook: consumers list this object in effect dependency
// arrays, so a fresh identity per render re-fires those effects on every render.
const toastApi = {
  success: (message: string) =>
    toast.success(message, {
      style: { ...defaultStyles, backgroundColor: 'rgb(var(--default-green))' },
      icon: <CheckIcon />,
    }),
  error: (message: string, options?: { duration?: number }) =>
    toast.error(message, {
      style: { ...defaultStyles, backgroundColor: 'rgb(var(--default-red))' },
      icon: <WarningIcon />,
      ...options,
    }),
  warning: (message: string) =>
    toast.error(message, {
      style: { ...defaultStyles, backgroundColor: 'rgb(var(--default-orange))' },
      icon: <WarningIcon />,
    }),
  info: (message: string) =>
    toast(message, {
      style: { ...defaultStyles },
    }),
};

export const useToast = () => toastApi;

export const Toaster = () => {
  return (
    <ToasterPrimitive containerStyle={{ top: 20 }} toastOptions={{ duration: 4000 }}>
      {(t) => (
        <ToastBar toast={t} style={{ width: '400px' }}>
          {({ icon, message }) => (
            <div className="flex w-full items-center justify-between gap-2">
              <div className="flex min-w-0 items-center justify-start gap-2">
                <div className="shrink-0">{icon}</div>
                <div className="max-w-full overflow-hidden pr-4 font-medium text-ellipsis whitespace-nowrap [&>div]:!m-0 [&>div]:!justify-start">{message}</div>
              </div>

              <CloseIcon className="shrink-0 cursor-pointer" onClick={() => toast.dismiss(t.id)} />
            </div>
          )}
        </ToastBar>
      )}
    </ToasterPrimitive>
  );
};
